const JSON_SCRIPT_ESCAPE_PATTERN = /[<>&\u2028\u2029]/g;

const JSON_SCRIPT_ESCAPE_MAP: Record<string, string> = {
  "<": "\\u003C",
  ">": "\\u003E",
  "&": "\\u0026",
  "\u2028": "\\u2028",
  "\u2029": "\\u2029",
};

export function serializeJsonForScript(value: unknown): string {
  const serialized = JSON.stringify(value);
  if (serialized === undefined) {
    return "null";
  }

  return serialized.replace(
    JSON_SCRIPT_ESCAPE_PATTERN,
    (character) => JSON_SCRIPT_ESCAPE_MAP[character] ?? character,
  );
}
